"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _theme_1 = require("@theme");
const _store_1 = __importDefault(require("@store")); // Component
var AccountWelcome = function AccountWelcome() {
    // const [ , setPanel] = useGlobal( state => state.panel, actions => actions.setPanel)
    var _useGlobal = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal[1];
    var skip = function skip() {
        return setVisibleDropdown(undefined);
    };
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        orderReverse: true,
        alignCenter: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Welcome Home"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Welcome to PRIOR, take a moment to explore your account."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Get started by viewing some of our ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/bookmarks"
    }, "suggested bookmarks"), " and get inspired for your next trip, or ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "#",
        onClick: function onClick() {
            return skip();
        }
    }, "skip for now"), "."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        to: "/bookmarks",
        size: "large",
        shadow: true
    }, "Get Started")))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.StyledImage, {
        src: "/images/accounts/welcome.png",
        objectFit: "contain"
    })));
}; // Styling
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountWelcome__StyledLink",
    componentId: "a3oapr-0"
})(["color:", ";"], _theme_1.palette.brown);
exports.default = AccountWelcome;
